import { CurrentClient } from "../features/auth/types";

export function getSentimentValues(
    sentiment: 'positive' | 'neutral' | 'negative' | 'alert',
    currentClient: CurrentClient | undefined
): string[] {
    switch (sentiment) {
        case 'positive':
            return Array.from(
                {
                length:
                    (currentClient?.sentimentMaximumValue || 5) -
                    (currentClient?.positiveReference || 0) + 1
                },
                (_, i) => i + (currentClient?.positiveReference || 0)
            ).map(String);

        case 'neutral':
            if (
                currentClient?.neutralReference !== undefined &&
                currentClient?.positiveReference !== undefined
            ) {
                return Array.from(
                {
                    length:
                    currentClient.positiveReference -
                    currentClient.neutralReference
                },
                (_, i) => i + currentClient.neutralReference
                ).map(String);
            }

            return [];

        case 'negative':
            return Array.from(
                {
                length: currentClient?.neutralReference
                    ? currentClient.neutralReference - 1
                    : 0
                },
                (_, i) => i + (currentClient?.sentimentMinimumValue || 0)
            ).map(String);

        case 'alert':
            return Array.from(
                {
                    length: currentClient?.alertReference || 1
                },
                (_, i) => i + (currentClient?.alertMinimumValue || 0)
            ).map(String);

        default:
            return [];
    }
}